import { all, fork, call, put, takeEvery, takeLatest } from 'redux-saga/effects'

import watcherSearch from './search';

export default function* sagas() {
  yield all([
    fork(watcherSearch),
  ])
}